import { render, staticRenderFns } from "./NsimRules.vue?vue&type=template&id=d44c5a64&"
import script from "./NsimRules.vue?vue&type=script&lang=js&"
export * from "./NsimRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports